import { DataAvailabilityKey, RawAvailability, WidgetDataAvailability } from 'domain/entity/widgetData';

export const checkIfHasMainData = (dataAvailabilityParam: WidgetDataAvailability): boolean =>
    (dataAvailabilityParam.enabled &&
        dataAvailabilityParam.rawAvailabilities.some(
            (dataAvailability: RawAvailability) => dataAvailability.key === DataAvailabilityKey.MAIN && dataAvailability.available > 0
        )) ||
    !dataAvailabilityParam.enabled;

export const checkIfHasComparisonData = (dataAvailabilityParam: WidgetDataAvailability): boolean =>
    (dataAvailabilityParam.enabled &&
        dataAvailabilityParam.rawAvailabilities.some(
            (dataAvailability: RawAvailability) => dataAvailability.key === DataAvailabilityKey.COMPARISON && dataAvailability.available > 0
        )) ||
    !dataAvailabilityParam.enabled;
